;(() => {
  // Content Tabs Functionality
  const setActiveContent = (section, activeId) => {
    const contentEls = section.querySelectorAll('.twi-content-tabs__content')

    contentEls.forEach((el) => {
      el.classList.remove('twi-content-tabs__content--active')
      el.classList.remove('animate')
    })

    const activeContent = section.querySelector(`[data-content-tab-id="${activeId}"].twi-content-tabs__content`)

    if (activeContent) {
      activeContent.classList.add('twi-content-tabs__content--active')
      setTimeout(() => {
        activeContent.classList.add('animate')
      }, 100)
    }
  }

  const toggleTab = (section) => {
    const tabs = section.querySelectorAll('.twi-content-tabs__tab')

    tabs.forEach((tab) => {
      const currentId = tab.dataset.contentTabId

      tab.addEventListener('click', (event) => {
        if (!event.currentTarget.classList.contains('twi-content-tabs__tab--active')) {
          tabs.forEach((el) => {
            el.classList.remove('twi-content-tabs__tab--active')
            const icon = el.querySelector('.icon')
            if (icon) {
              icon.classList.remove('icon-minus')
              icon.classList.add('icon-plus')
              const svg = icon.querySelector('svg')
              svg.innerHTML = `
                <path d="M10 6V16M15 11L5 11" stroke="currentColor" stroke-width="1.4" stroke-linecap="square"/>
              `
            }
          })

          tab.classList.add('twi-content-tabs__tab--active')
          const icon = tab.querySelector('.icon')
          if (icon) {
            icon.classList.remove('icon-plus')
            icon.classList.add('icon-minus')
            const svg = icon.querySelector('svg')
            svg.innerHTML = `
              <path d="M15 11L5 11" stroke="currentColor" stroke-width="1.4" stroke-linecap="square"/>
            `
          }

          setActiveContent(section, currentId)
        }
      })

      tab.addEventListener('keydown', (event) => {
        if (!event.currentTarget.classList.contains('twi-content-tabs__tab--active') && event.key === 'Enter') {
          tabs.forEach((el) => {
            el.classList.remove('twi-content-tabs__tab--active')
            const icon = el.querySelector('.icon')
            if (icon) {
              icon.classList.remove('icon-minus')
              icon.classList.add('icon-plus')
              const svg = icon.querySelector('svg')
              svg.innerHTML = `
                <path d="M10 6V16M15 11L5 11" stroke="currentColor" stroke-width="1.4" stroke-linecap="square"/>
              `
            }
          })

          tab.classList.add('twi-content-tabs__tab--active')
          const icon = tab.querySelector('.icon')
          if (icon) {
            icon.classList.remove('icon-plus')
            icon.classList.add('icon-minus')
            const svg = icon.querySelector('svg')
            svg.innerHTML = `
              <path d="M15 11L5 11" stroke="currentColor" stroke-width="1.4" stroke-linecap="square"/>
            `
          }

          setActiveContent(section, currentId)
        }
      })
    })
  }

  const setWidthForAfter = (section) => {
    const wrapper = section.querySelector('.twi-content-tabs__tabs-wrapper')
    if (!wrapper) return

    const setVariable = (el) => {
      el.style.setProperty('--wrapper-border-width', `0px`)
      const elScrollWidth = el.scrollWidth
      el.style.setProperty('--wrapper-border-width', `${elScrollWidth}px`)
    }

    setVariable(wrapper)

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        setVariable(entry.target)
      })
    })
    resizeObserver.observe(wrapper)
  }

  // twi-slideshow Functionality
  const playVideo = (slider) => {
    if (slider.swiper) {
      const sliderSwiper = slider.swiper

      if (sliderSwiper.slides[sliderSwiper.previousIndex]) {
        const videoPrev = sliderSwiper.slides[sliderSwiper.previousIndex].querySelector('.twi-slideshow__video video')
        if (videoPrev) {
          videoPrev.pause()
        }
      }

      if (sliderSwiper.slides[sliderSwiper.activeIndex]) {
        const videoActive = sliderSwiper.slides[sliderSwiper.activeIndex].querySelector('.twi-slideshow__video video')
        if (videoActive) {
          videoActive.play()
        }
      }
    }
  }

  const stopVideo = (slider) => {
    if (slider.swiper) {
      const sliderSwiper = slider.swiper

      if (sliderSwiper.slides[sliderSwiper.activeIndex]) {
        const videoActive = sliderSwiper.slides[sliderSwiper.activeIndex].querySelector('.twi-slideshow__video video')
        if (videoActive) {
          videoActive.pause()
        }
      }
    }
  }

  const initSlider = (section) => {
    if (!section || !section.classList.contains('section-twi-slideshow')) return

    const box = section.querySelector('.twi-slideshow')

    if (box) {
      const swiperParams = {
        speed: 800,
        autoHeight: false,
        allowTouchMove: true,
        watchSlidesProgress: true,
        preventInteractionOnTransition: true,
        mousewheel: {
          forceToAxis: true,
        },
      }

      const changeColorScheme = (swiper) => {
        const activeIndex = swiper.activeIndex
        const activeSlide = swiper.slides[activeIndex]
        const colorScheme = activeSlide.dataset.colorScheme
        const exploreBtn = box.querySelector('.twi-slideshow__explore-btn')

        const changeItems = [
          swiper.navigation.nextEl,
          swiper.navigation.prevEl,
          swiper.pagination.el,
          ...(exploreBtn ? [exploreBtn] : []),
        ]

        changeItems.forEach((item) => {
          if (item) {
            let classNames = item.getAttribute('class')
            classNames = classNames.replace(/color-background-\d+/g, '')
            item.setAttribute('class', classNames)
            item.classList.add(colorScheme)
          }
        })
      }

      if (box.getAttribute('data-autoplay') === 'true') {
        swiperParams.autoplay = {
          disableOnInteraction: true,
        }
      }

      if (box.getAttribute('data-loop') === 'true') {
        swiperParams.loop = true
        swiperParams.loopPreventsSliding = false
      }

      if (box.getAttribute('data-pagination') === 'true') {
        const paginationEl = box.querySelector('.swiper-pagination')

        swiperParams.pagination = {
          el: paginationEl,
          type: 'bullets',
          clickable: true,
        }
      }

      if (box.getAttribute('data-parallax') === 'true') {
        swiperParams.parallax = true
      }

      if (box.getAttribute('data-animation-type') === 'fade') {
        swiperParams.effect = 'fade'
      } else {
        swiperParams.effect = 'slide'
      }

      if (box.getAttribute('data-full-width') === 'false') {
        swiperParams.breakpoints = {
          990: {
            spaceBetween: 16,
          },
        }
      }

      if (box.getAttribute('data-layout') === 'overlay') {
        const sliderOverlay = box.querySelector('.twi-slideshow__swiper--overlay')

        if (sliderOverlay) {
          const swiperOverlay = new Swiper(sliderOverlay, swiperParams)

          changeColorScheme(swiperOverlay)
          swiperOverlay.on('slideChange', function () {
            changeColorScheme(swiperOverlay)
            playVideo(sliderOverlay)
          })
        }
      } else if (box.getAttribute('data-layout') === 'split_screen') {
        const sliderText = box.querySelector('.twi-slideshow__swiper--text')
        const sliderMedia = box.querySelector('.twi-slideshow__swiper--media')

        if (box.getAttribute('data-full-width') === 'false') {
          swiperParams.spaceBetween = 8
          swiperParams.breakpoints = {
            990: {
              spaceBetween: 16,
            },
          }
        }

        if (sliderText && sliderMedia) {
          const swiperText = new Swiper(sliderText, swiperParams)

          const swiperMedia = new Swiper(sliderMedia, {
            ...swiperParams,
            autoplay: false,
            pagination: false,
            navigation: false,
            parallax: false,
          })

          swiperText.controller.control = swiperMedia
          swiperMedia.controller.control = swiperText

          changeColorScheme(swiperText)
          swiperText.on('slideChange', function () {
            changeColorScheme(swiperText)
          })
          swiperMedia.on('slideChange', function () {
            playVideo(sliderMedia)
          })
        }
      }
    }
  }

  const initScrollToExplore = (section) => {
    if (!section || !section.classList.contains('section-twi-slideshow')) return

    const scrollBtn = section.querySelector('.twi-slideshow__explore-btn')
    if (!scrollBtn) return

    const nextSection = section.nextElementSibling

    scrollBtn.addEventListener('click', () => {
      if (nextSection) {
        nextSection.scrollIntoView({ behavior: 'smooth' })
        return
      }

      section.scrollIntoView({ behavior: 'smooth' })
    })

    scrollBtn.addEventListener('keydown', (event) => {
      if (nextSection && event.key === 'Enter') {
        nextSection.scrollIntoView({ behavior: 'smooth' })
        return
      }

      section.scrollIntoView({ behavior: 'smooth' })
    })
  }

  const initSection = (section) => {
    if (!section) return

    // Initialize Content Tabs
    if (section.classList.contains('twi-content-tabs-section')) {
      toggleTab(section)
      setWidthForAfter(section)
    }

    // Initialize twi-slideshow
    if (section.classList.contains('section-twi-slideshow')) {
      initSlider(section)
      initScrollToExplore(section)

      const box = section.querySelector('.twi-slideshow')
      let slider
      if (box && box.getAttribute('data-layout') === 'overlay') {
        slider = section.querySelector('.twi-slideshow__swiper')
      } else if (box && box.getAttribute('data-layout') === 'split_screen') {
        slider = section.querySelector('.twi-slideshow__swiper--media')
      }

      if (slider) {
        const sectionObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              playVideo(slider)
              if (slider.swiper && slider.getAttribute('data-autoplay') === 'true') {
                slider.swiper.autoplay.resume()
              }
            } else {
              stopVideo(slider)
              if (slider.swiper && slider.getAttribute('data-autoplay') === 'true') {
                slider.swiper.autoplay.pause()
              }
            }
          })
        })
        sectionObserver.observe(section)
      }
    }
  }

  // Initialize both sections
  initSection(document.currentScript.parentElement)

  // Handle dynamic section loading
  document.addEventListener('shopify:section:load', function (event) {
    initSection(event.target)
  })
})()
